module.exports = "mutation ($id: ID!, $data: OpenhouseUpdate!) {\n  OpenhouseUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"